import React from 'react';
import './Nav.css';
import { NavLink } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { translate } from '../../i18n';
import { RootState } from '../../store';

export interface INavTabProps {
    icon: React.HTMLAttributes<HTMLDivElement>;
    title: string;
    to: string;
    index: number;
    setActiveTab: (index: number) => void;
}

const NavTab: React.FC<INavTabProps> = (props) => {
    const { language } = useSelector((state: RootState) => state.lang);

    return (
        <NavLink
            to={props.to}
            onClick={() => props.setActiveTab(props.index)}
            className={({ isActive }) => (isActive ? 'NavTab active DropShadow"' : 'NavTab DropShadow"')}
            style={{ textDecoration: 'none' }}
            children={({ isActive }) => {
                return (
                    <>
                        {props.icon}
                        <div className="NavTabTitle">{translate(props.title, language)}</div>
                    </>
                );
            }}
        />
    );
};

export default NavTab;
